const global = {
  actions: {
    /**
     * 全局请求头（可设置Token），传参包含请求URL，可做更细处理
     * 支持返回Promise
     */
    globalRequestHeaders: function () {
      return {}
    }
  }
}

export default global
